var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 20.86,
    cy: 11.11,
    r: 1.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.44 11.11h11.91a3.24 3.24 0 013.24 3.24v21.69a3.24 3.24 0 01-3.24 3.24H6.17a3.24 3.24 0 01-3.24-3.24V14.35a3.24 3.24 0 013.24-3.24h11.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15.83 15.17V29.3l5.03-4.11 5.03 4.35V15.17M24.11 7.52L27 4.67c1.84-2.21 5.36-1.76 6.58.85 1.22 2.61-.69 5.6-3.57 5.59h-5.58M17.33 7.58l-2.66-2.92c-1.84-2.21-5.36-1.76-6.58.85-1.22 2.61.69 5.6 3.57 5.59h5.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.67321a18ad7b555f892a75085fe83e72.svg";
export { ForwardRef as ReactComponent };